const isMovableDateHoliday = (holidays, month, dayOfWeek, weekOfMonth) => holidays.some(holiday => holiday.month === month && holiday.dayOfWeek === dayOfWeek && holiday.weekOfMonth === weekOfMonth);
export default isMovableDateHoliday;
//# sourceMappingURL=isMovableDateHoliday.js.map